import CreateArticleSearchTagModal from '../../../../../CreateArticleSearchTagModal'
import { useState } from 'react'
import Button, { TButtonProps } from '../../../../../../../../../../../shared/Buttons/Button/Button'

interface IArticleSearchTagsCreateBtnProps {
  theme?: TButtonProps['theme']
}

const ArticleSearchTagsCreateBtn = ({ theme = 'grey-outline' }: IArticleSearchTagsCreateBtnProps) => {
  const [createArticleSearchTagModalOpen, setCreateArticleSearchTagModalOpen] = useState(false)

  return (
    <>
      <Button theme={theme} onClick={() => setCreateArticleSearchTagModalOpen(true)} style={{ width: 'fit-content' }}>
        + Создать тег
      </Button>
      {createArticleSearchTagModalOpen && (
        <CreateArticleSearchTagModal onClose={() => setCreateArticleSearchTagModalOpen(false)} />
      )}
    </>
  )
}

export default ArticleSearchTagsCreateBtn
